import patchInternals from './script/internals';
patchInternals();
